import ProfilePage from './ProfilePage.page';

export default ProfilePage;